"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ShippingKitPackagingReportLine = void 0;
const responses_1 = require("../../sales-order/responses");
class ShippingKitPackagingReportLine {
}
exports.ShippingKitPackagingReportLine = ShippingKitPackagingReportLine;
//# sourceMappingURL=shipping-kit-packaging-report-line.response.js.map